export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-credit-card-9f7a90c58b77a540a7fd4aa8d69600ef.svg";